import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  DocFlowSendingWidgetNotificationType,
  DocFlowSendingWidgetProcessFieldName,
} from '../../DocFlowSending'
import {
  getDocFlowSendingCommunicationSettingsPermanentNotifications,
  getDocFlowSendingCommunicationSettingsWidgetNotifications,
} from '../../DocFlowWidgets'
import { useDocFlowContext } from '../useDocFlowContext'
import { useDocFlowSendingContext } from '../useDocFlowSendingContext'
import { useDocFlowSendingWidgetNotifications } from '../useDocFlowSendingWidgetNotifications'

export function useDocFlowCommunicationSettings({ index }) {
  const { phaseDisabled } = useDocFlowContext()

  const { handleClickNextWidget } = useDocFlowSendingContext()

  const { t } = useTranslation()

  const [isError, setError] = useState(false)

  const widgetNotifications =
    getDocFlowSendingCommunicationSettingsWidgetNotifications(t)

  const { handlePrependNotification, handleRemoveNotification, notifications } =
    useDocFlowSendingWidgetNotifications({
      getInitialNotifications:
        getDocFlowSendingCommunicationSettingsPermanentNotifications,
      phase: DocFlowSendingWidgetProcessFieldName.CommunicationSettingsPhase,
      widgetNotifications,
    })

  async function handleClickNext() {
    if (phaseDisabled) {
      return handleClickNextWidget(index)
    }

    handleClickNextWidget()
      .then(() => {
        handleRemoveNotification(
          widgetNotifications[DocFlowSendingWidgetNotificationType.Error].id
        )

        setError(false)
      })
      .catch(() => {
        handlePrependNotification(
          widgetNotifications[DocFlowSendingWidgetNotificationType.Error]
        )

        handleRemoveNotification(
          widgetNotifications[DocFlowSendingWidgetNotificationType.Success].id
        )

        setError(true)
      })
  }

  return {
    handleClickNext,
    isError,
    notifications,
  }
}
